import {
  LOAD_DEVICE_RESOURCES_SUCCESS,
  UNLOAD_DEVICE_RESOURCES,
} from "fleet/redux-store/ui-state/device-resources/actions.js";

const initialState = {};

function deviceResourceReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case LOAD_DEVICE_RESOURCES_SUCCESS:
      return {
        resources: payload.data,
      };
    case UNLOAD_DEVICE_RESOURCES:
      return initialState;
    default:
      return state;
  }
}

export { deviceResourceReducer };
